// extracted by mini-css-extract-plugin
export var container = "_4d-0";
export var disabled = "_4d-4";
export var fullWidth = "_4d-3";
export var lined = "_4d-1";
export var selected = "_4d-5";
export var tab = "_4d-2";